module.exports = __webpack_public_path__ + "img/ft_maize.45397d4f.jpg";